/*
 * Maya Mountain — Field Atlas V2
 * Scroll motion: native view() timelines when supported; IntersectionObserver
 * fallback at 480ms. Video plays only after an explicit click.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-mo-atlas]');
  if (!root) return;

  root.classList.add('is-enhanced');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Document rendu hors ecran (onglet d'arriere-plan, fenetre occultee,
     restauration de session, retour bfcache) : ni requestAnimationFrame, ni
     IntersectionObserver, ni timeline view() n'y avancent. Aucune
     choregraphie n'y est jouable — on rend l'etat final plutot que de laisser
     la page a opacite 0. Defaut observe le 2026-08-24 : M3 restait une bande
     ivoire vide, sans aucune photographie. */
  var startedHidden = !!(document.visibilityState && document.visibilityState !== 'visible');

  var hasView = false;
  try {
    hasView = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()'));
  } catch (e) {
    hasView = false;
  }
  var isNarrow = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  if (hasView && !reduceMotion && !startedHidden && !isNarrow) {
    root.classList.add('is-view');
  }

  /* Deux familles distinctes d'elements masquables : celles qu'ouvre
     `.is-visible`, et les cadres M3/M4 qu'ouvre `.is-in`. Le filet doit
     nommer les deux — l'ancien n'en couvrait qu'une. */
  var HIDEABLE = '[data-mo-reveal], [data-mo-uncloak], [data-mo-reveal-group], .mo-reveal, .mo-uncloak';
  var ENTERABLE = '.mo-atlas__m3-window, .mo-atlas__m3-panel, .mo-atlas__m4-grove, .mo-atlas__m4-live, .mo-atlas__m4-tangle, .mo-atlas__m4-plate';

  var revealEverything = function () {
    /* Retirer `is-view` fait retomber la page sur les regles `:not(.is-view)`,
       que `.is-visible` sait ouvrir. Sans ca, une timeline view() figee a 0 %
       garde ses elements a opacite 0 quelle que soit la classe ajoutee. */
    root.classList.remove('is-view');
    root.querySelectorAll(HIDEABLE).forEach(function (el) {
      el.classList.add('is-visible');
    });
    root.querySelectorAll(ENTERABLE).forEach(function (el) {
      el.classList.add('is-in');
    });
  };

  if (startedHidden) {
    revealEverything();
  } else {
    /* Sonde exacte : une frame d'animation a-t-elle ete servie ? Si non, le
       moteur de mouvement ne tourne pas. L'ancienne sonde testait
       `aucun .is-visible dans la page` — globale, donc desarmee des qu'un
       seul element etait revele ailleurs (c'etait le cas des le chargement). */
    var rafServed = false;
    if ('requestAnimationFrame' in window) {
      window.requestAnimationFrame(function () { rafServed = true; });
    }
    window.setTimeout(function () {
      if (rafServed && 'IntersectionObserver' in window) return;
      revealEverything();
    }, 2000);
  }

  /* Native view() already drives reveals; skip IO motion on those browsers. */
  var useIoMotion = (!hasView || reduceMotion) && !startedHidden;

  var revealTargets = root.querySelectorAll('[data-mo-reveal], [data-mo-uncloak], .mo-reveal, .mo-uncloak');
  if (useIoMotion) {
    if ('IntersectionObserver' in window && revealTargets.length && !reduceMotion) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            } else {
              entry.target.classList.remove('is-visible');
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px -12% 0px' }
      );
      revealTargets.forEach(function (el) {
        revealObserver.observe(el);
      });
    } else {
      revealTargets.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  var groups = root.querySelectorAll('[data-mo-reveal-group]');
  if (useIoMotion && 'IntersectionObserver' in window && groups.length && !reduceMotion) {
    var groupObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var items = entry.target.querySelectorAll('.mo-atlas__frame, .mo-atlas__species-item, .mo-atlas__m3-window, .mo-atlas__m3-panel, .mo-atlas__tile');
          var stagger = 80;
          if (entry.target.classList.contains('mo-atlas__species')) stagger = 70;
          if (entry.target.classList.contains('mo-atlas__m7-grid')) stagger = 80;
          if (entry.isIntersecting) {
            items.forEach(function (item, i) {
              item.style.transitionDelay = i * stagger + 'ms';
            });
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
            items.forEach(function (item) {
              item.style.transitionDelay = '';
            });
          }
        });
      },
      { threshold: 0.12 }
    );
    groups.forEach(function (el) {
      groupObserver.observe(el);
    });
  } else {
    groups.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* Count-up removed: factual figures render as static Liquid text. */

  /* M3 enter — une seule entree, jouee une fois, puis l'element reste visible.
     Seuil 0 + marge basse plutot qu'un ratio : un ratio de 0,14 n'est jamais
     atteint sur un element plus haut que la fenetre, et un defilement rapide
     peut livrer l'entree avec un ratio deja retombe a 0. La marge basse de
     12 % fait le travail que le ratio faisait — declencher un peu apres le
     bord — sans en avoir la fragilite. */
  var m3Enter = root.querySelectorAll('.mo-atlas__m3-window, .mo-atlas__m3-panel');
  var m3Stage = root.querySelector('.mo-atlas__m3-stage');
  if (m3Enter.length) {
    var m3ShowAll = function () {
      m3Enter.forEach(function (el) {
        el.classList.add('is-in');
      });
    };
    if (reduceMotion || startedHidden || !('IntersectionObserver' in window) || !m3Stage) {
      m3ShowAll();
    } else {
      /* UN SEUL declencheur, pose sur la scene entiere — pas un par cadre.

         Mesure du 2026-08-25 a 1440x757, defilement lent : observes un par un,
         le tri et le sechage partaient ensemble (meme bord haut), le panneau
         55 ms plus tard, et le sac 413 ms plus tard parce qu'il est ~360 px
         plus bas dans la composition. Les delais CSS, censes PRODUIRE la
         cadence, venaient alors s'ajouter a ce retard : departs reels a
         0 / 165 / 221 / 743 ms au lieu de 0 / 110 / 220 / 330. L'ordre narratif
         etait juste, la cadence non — quatre entrees independantes qui se
         ressemblent, pas une choregraphie commune.

         Avec un declencheur unique, les quatre pieces recoivent `is-in` dans le
         meme cycle et les delais CSS restent la seule source de cadence. La
         cadence ne depend donc plus de la position verticale propre au sac.

         Le seuil reste a 0 avec une marge basse de 12 % : un ratio d'intersection
         n'est jamais atteint sur un element plus haut que la fenetre, et un
         defilement rapide peut livrer l'entree avec un ratio deja retombe a 0. */
      var m3StageObs = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              m3ShowAll();
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px -12% 0px' }
      );
      m3StageObs.observe(m3Stage);
    }
  }

  /* M2 — the three photos arrive closed in a fan and open on scroll.
     Progress starts while the previous section is still leaving the screen. */
  var m2Plates = root.querySelector('.mo-atlas__m2-plates');
  if (m2Plates && m2Plates.classList.contains('mo-atlas__plate--count-2')) {
    m2Plates.style.setProperty('--m2-shut', '0');
  } else if (m2Plates && !reduceMotion && 'requestAnimationFrame' in window) {
    var m2Tick = false;
    var updateM2Fan = function () {
      m2Tick = false;
      if (window.innerWidth < 750) {
        m2Plates.style.setProperty('--m2-shut', '0');
        return;
      }
      var rect = m2Plates.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      /* Starts a third of a screen before the plate appears, ends once it sits
         high in the view: the fan opens over roughly one full screen of scroll. */
      var open = (vh * 1.35 - rect.top) / (vh * 1.05);
      if (open < 0) open = 0;
      if (open > 1) open = 1;
      /* Smoothstep: eases in and out, so the travel reads mid-course
         instead of being spent before the section is even on screen. */
      open = open * open * (3 - 2 * open);
      m2Plates.style.setProperty('--m2-shut', (1 - open).toFixed(3));
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!m2Tick) {
          m2Tick = true;
          window.requestAnimationFrame(updateM2Fan);
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', updateM2Fan);
    updateM2Fan();
  }

  /* Inner pan — frame stays still, the photo moves inside the clip. */
  if (!reduceMotion) {
    var panPairs = [
      {
        img: root.querySelector('.mo-atlas__m4-grove img'),
        clip: root.querySelector('.mo-atlas__m4-grove-clip'),
        travel: -12,
        scale: 1.16
      }
    ].filter(function (pair) { return pair.img && pair.clip; });

    /* Le mecanisme « cadre vivant » (panoramique interne d'une photo encadree,
       pilote au defilement) a ete retire le 2026-08-24. Il n'avait qu'un seul
       usage — la photo de tri de M3 — et c'etait precisement le probleme : une
       seule des quatre pieces de M3 bougeait en continu, les trois autres non.
       La composition lisait « photo selectionnee » au lieu de « planche de
       terrain ». M3 a desormais une entree commune, en CSS. */
    if (panPairs.length) {
      var panTicking = false;
      var updatePan = function () {
        panTicking = false;
        var vh = window.innerHeight || 1;
        panPairs.forEach(function (pair) {
          var rect = pair.clip.getBoundingClientRect();
          var progress = (vh - rect.top) / (vh + rect.height);
          if (progress < 0) progress = 0;
          if (progress > 1) progress = 1;
          var move = 'translate3d(0,' + (progress * pair.travel).toFixed(2) + '%,0)';
          pair.img.style.transform = pair.scale
            ? move + ' scale(' + pair.scale + ')'
            : move;
        });
      };
      var onPanScroll = function () {
        if (!panTicking) {
          panTicking = true;
          window.requestAnimationFrame(updatePan);
        }
      };
      updatePan();
      window.addEventListener('scroll', onPanScroll, { passive: true });
      window.addEventListener('resize', onPanScroll);
    }
  }

  /* M4 — fade in + progressive slide right → left. */
  var m4Section = root.querySelector('.mo-atlas__m4');
  var m4Field = root.querySelector('.mo-atlas__m4-field');
  var m4Enter = root.querySelectorAll('.mo-atlas__m4-grove, .mo-atlas__m4-live, .mo-atlas__m4-tangle, .mo-atlas__m4-plate');
  if (m4Enter.length) {
    if (reduceMotion || startedHidden || !('IntersectionObserver' in window)) {
      m4Enter.forEach(function (el) {
        el.classList.add('is-in');
      });
    } else {
      var m4EnterObs = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.12) {
              entry.target.classList.add('is-in');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: [0.12, 0.28], rootMargin: '0px 0px -6% 0px' }
      );
      m4Enter.forEach(function (el) {
        m4EnterObs.observe(el);
      });
    }
  }
  if (m4Section && !reduceMotion && 'requestAnimationFrame' in window) {
    var m4Tick = false;
    var updateM4Slide = function () {
      m4Tick = false;
      var rect = m4Section.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var open = (vh * 0.88 - rect.top) / (vh * 0.52);
      if (open < 0) open = 0;
      if (open > 1) open = 1;
      m4Section.style.setProperty('--m4-open', open.toFixed(3));
      if (m4Field) m4Field.style.setProperty('--m4-slide', open.toFixed(3));
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!m4Tick) {
          m4Tick = true;
          window.requestAnimationFrame(updateM4Slide);
        }
      },
      { passive: true }
    );
    updateM4Slide();
  }

  /* Scene background morph — parchemin → ivoire → argile → cacao */
  var sceneMap = {
    cacao: 'rgb(50, 29, 16)',
    parchment: 'rgb(246, 227, 208)',
    ivory: 'rgb(234, 201, 168)',
    clay: 'rgb(168, 118, 74)'
  };
  var scenes = root.querySelectorAll('[data-mo-bg]');
  if ('IntersectionObserver' in window && scenes.length) {
    var originHandle = (root.getAttribute('data-mo-origin') || '').trim();
    var setScene = function (name) {
      var narrow = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var color = sceneMap[name] || sceneMap.parchment;
      if (narrow && name !== 'parchment' && name !== 'ivory') {
        color = sceneMap.parchment;
      }
      document.documentElement.style.setProperty('--moojo-scene-bg', color);
      document.body.style.backgroundColor = color;
    };
    var sceneNameFor = function (el) {
      var name = el.getAttribute('data-mo-bg');
      if (
        name === 'cacao' &&
        el.id === 'origin-post-recolte' &&
        originHandle === 'chuncho-urubamba'
      ) {
        return 'clay';
      }
      return name;
    };
    var sceneObserver = new IntersectionObserver(
      function (entries) {
        var visible = entries
          .filter(function (entry) { return entry.isIntersecting; })
          .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; });
        if (visible[0]) {
          setScene(sceneNameFor(visible[0].target));
        }
      },
      { threshold: [0.25, 0.5, 0.75], rootMargin: '-20% 0px -30% 0px' }
    );
    scenes.forEach(function (el) {
      sceneObserver.observe(el);
    });
  }

  /* rAF parallax only when view() is unavailable (M1 recede fallback). */
  if (!hasView && !reduceMotion && 'requestAnimationFrame' in window) {
    var m1 = root.querySelector('.mo-atlas__m1');
    var ticking = false;
    var clamp01 = function (n) {
      return n < 0 ? 0 : n > 1 ? 1 : n;
    };
    var updateScroll = function () {
      if (m1) {
        var vh = window.innerHeight || 800;
        var recede = clamp01((vh - m1.getBoundingClientRect().bottom) / (vh * 0.25));
        if (m1.getBoundingClientRect().bottom >= vh) recede = 0;
        m1.style.setProperty('--recede', recede.toFixed(3));
      }
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
    updateScroll();
  }

  var cinema = root.querySelector('[data-mo-video-frame]');
  var posterBtn = root.querySelector('[data-mo-video-poster]');
  var playerWrap = root.querySelector('[data-mo-video-player]');
  var iframe = root.querySelector('[data-mo-iframe]');

  if (posterBtn && playerWrap && iframe) {
    posterBtn.addEventListener('click', function () {
      var src = iframe.getAttribute('data-src-play');
      if (src) {
        iframe.setAttribute('src', src);
      }
      playerWrap.hidden = false;
      posterBtn.hidden = true;
      if (cinema) cinema.classList.add('is-playing');
    });
  }

  var micronav = root.querySelector('.mo-atlas__micronav');
  if (micronav) {
    var navLinks = Array.prototype.slice.call(micronav.querySelectorAll('a[href^="#"]'));
    var navSections = [];
    navLinks.forEach(function (link) {
      var id = (link.getAttribute('href') || '').replace('#', '');
      var section = id ? document.getElementById(id) : null;
      if (!section) return;
      navSections.push(section);
    });
    if (navSections.length) {
      var setActive = function (id) {
        navLinks.forEach(function (link) {
          var on = (link.getAttribute('href') || '') === '#' + id;
          link.classList.toggle('is-active', on);
          if (on) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      var navTicking = false;
      var updateNav = function () {
        navTicking = false;
        var marker = window.innerHeight * 0.32;
        var current = navSections[0];
        navSections.forEach(function (section) {
          if (section.getBoundingClientRect().top <= marker) current = section;
        });
        if (current && current.id) setActive(current.id);
      };
      window.addEventListener(
        'scroll',
        function () {
          if (!navTicking) {
            navTicking = true;
            window.requestAnimationFrame(updateNav);
          }
        },
        { passive: true }
      );
      updateNav();
    }
  }
})();
